<div class="content">
  <div id="header-breadcrumbs" class="header-breadcrumbs">
    <!-- Dynamic breadcrumb navigation -->
    <nav class="breadcrumb" aria-label="breadcrumb">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
        <a *ngIf="!last && crumb.link" [routerLink]="crumb.link" class="breadcrumb-link">{{ crumb.label }}</a>
        <span *ngIf="last || !crumb.link" class="breadcrumb-current">{{ crumb.label }}</span>
        <span *ngIf="!last" class="breadcrumb-separator"> / </span>
      </ng-container>
    </nav>
  </div>

  <div id="ema-batch-header" class="ema-batch-header">
    <h2>Batch Headers</h2>
    <p class="ema-batch-header-subtitle">
      The batch headers page provides an overview of all EMA batches. You can
      search for specific batches using the search bar, and click on a batch ID
      to view its details.
    </p>
  </div>

  <!-- Search and Filters -->
  <div class="table-container">
    <div class="filter-bar">
      <!-- Search Field -->
      <mat-form-field class="filter-form-field" appearance="outline">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyTextFilter($event)" placeholder="Search all columns" />
      </mat-form-field>

      <!-- Start Date Filter -->
      <mat-form-field class="filter-form-field" appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startPicker" [(ngModel)]="filters.startDate" (dateChange)="onFilterChange()" />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <!-- End Date Filter -->
      <mat-form-field class="filter-form-field" appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endPicker" [(ngModel)]="filters.endDate" (dateChange)="onFilterChange()" />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <!-- Status Filter -->
      <!-- <mat-form-field class="filter-form-field" appearance="outline">
        <mat-label>Status</mat-label>
        <input matInput [(ngModel)]="filters.status" (keyup)="onFilterChange()" placeholder="Filter by status" />
      </mat-form-field> -->

      <!-- Export Button -->
      <button mat-raised-button color="accent" (click)="onExport()" 
      class="export-button" title="Export table data displayed in UI">
        Export UI
      </button>
    </div>

    <!-- AG Grid Table -->
    <ag-grid-angular class="ag-theme-alpine ag-grid-container" [rowData]="filteredRowData" [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [pagination]="true" [paginationPageSize]="20" [animateRows]="true"
      [context]="gridContext" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>